import PowerSelectMultiple from 'ember-power-select/components/power-select-multiple';
import PaginatedSelect from 'garaje/components/paginated-select';

import ScrollAwareOptions from './scroll-aware-options';

export default class PaginatedSelectMultiple<T> extends PaginatedSelect<T> {
  // This solves a problem where TS/Glint don't handle passing template types using the `component` helper, with this error:
  // error TS2589: Type instantiation is excessively deep and possibly infinite.
  // Putting this on the class (and passing it to `component`, instead of the imported component) "fixes" the issue.
  ScrollAwareOptions = ScrollAwareOptions<T>;

  <template>
    <PowerSelectMultiple
      @afterOptionsComponent={{@afterOptionsComponent}}
      @allowClear={{@allowClear}}
      @animationEnabled={{@animationEnabled}}
      @ariaDescribedBy={{@ariaDescribedBy}}
      @ariaInvalid={{@ariaInvalid}}
      @ariaLabel={{@ariaLabel}}
      @ariaLabelledBy={{@ariaLabelledBy}}
      @beforeOptionsComponent={{@beforeOptionsComponent}}
      @buildSelection={{@buildSelection}}
      @calculatePosition={{@calculatePosition}}
      @closeOnSelect={{@closeOnSelect}}
      @defaultHighlighted={{@defaultHighlighted}}
      @destination={{@destination}}
      @disabled={{@disabled}}
      @dropdownClass={{@dropdownClass}}
      @extra={{@extra}}
      @groupComponent={{@groupComponent}}
      @highlightOnHover={{@highlightOnHover}}
      @horizontalPosition={{@horizontalPosition}}
      @initiallyOpened={{@initiallyOpened}}
      @loadingMessage={{@loadingMessage}}
      @eventType={{@eventType}}
      @matcher={{@matcher}}
      @matchTriggerWidth={{@matchTriggerWidth}}
      @noMatchesMessage={{@noMatchesMessage}}
      @onBlur={{@onBlur}}
      @onChange={{@onChange}}
      @onClose={{@onClose}}
      @onFocus={{@onFocus}}
      @onInput={{this.onInput}}
      @onKeydown={{@onKeydown}}
      @onOpen={{@onOpen}}
      @registerAPI={{this.registerAPI}}
      @options={{this.options}}
      @optionsComponent={{component this.ScrollAwareOptions onScroll=this._reportScroll}}
      @placeholder={{@placeholder}}
      @placeholderComponent={{@placeholderComponent}}
      @preventScroll={{@preventScroll}}
      @renderInPlace={{@renderInPlace}}
      @scrollTo={{@scrollTo}}
      @search={{this.search}}
      @searchEnabled={{@searchEnabled}}
      @searchField={{@searchField}}
      @searchMessage={{@searchMessage}}
      @searchPlaceholder={{@searchPlaceholder}}
      @selected={{@selected}}
      @selectedItemComponent={{@selectedItemComponent}}
      @tabindex={{@tabindex}}
      @triggerClass={{@triggerClass}}
      @triggerComponent={{@triggerComponent}}
      @triggerId={{@triggerId}}
      @triggerRole={{@triggerRole}}
      @verticalPosition={{@verticalPosition}}
      as |option|
    >
      {{yield option}}
    </PowerSelectMultiple>
  </template>
}
